/**
 * Add a separator between every element of an array.
 *
 * Similar to {@link Array.prototype.join}, but without forcing a string conversion.
 */
export function intersperse<TSep, T>(sep: TSep, arr: T[]) {
    const result: (T | TSep)[] = [];
    let first = true;
    for (const elem of arr) {
        if (!first) {
            result.push(sep);
        }
        result.push(elem);
        first = false;
    }
    return result;
}
